import { render, staticRenderFns } from "./PendingSamples.vue?vue&type=template&id=7c3243be"
import script from "./PendingSamples.vue?vue&type=script&lang=js"
export * from "./PendingSamples.vue?vue&type=script&lang=js"
import style0 from "./PendingSamples.vue?vue&type=style&index=0&id=7c3243be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports